import { render } from "./AdDocViewInvitations.vue?vue&type=template&id=314264a3&ts=true"
import script from "./AdDocViewInvitations.vue?vue&type=script&lang=ts"
export * from "./AdDocViewInvitations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__